import { render, staticRenderFns } from "./SingleContact.vue?vue&type=template&id=49cb3464&"
import script from "./SingleContact.vue?vue&type=script&lang=js&"
export * from "./SingleContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-stylebreaker-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49cb3464')) {
      api.createRecord('49cb3464', component.options)
    } else {
      api.reload('49cb3464', component.options)
    }
    module.hot.accept("./SingleContact.vue?vue&type=template&id=49cb3464&", function () {
      api.rerender('49cb3464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/SingleContact.vue"
export default component.exports